import { render, staticRenderFns } from "./List-Shipment-Detail.vue?vue&type=template&id=d7131c00&scoped=true"
import script from "./List-Shipment-Detail.vue?vue&type=script&lang=js"
export * from "./List-Shipment-Detail.vue?vue&type=script&lang=js"
import style0 from "./List-Shipment-Detail.vue?vue&type=style&index=0&id=d7131c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7131c00",
  null
  
)

export default component.exports